// Телефон анкеты карты — всегда +994XXXXXXXXX (решение владельца 24.10.2026).
//
// Азербайджанский номер в любой записи («050 123 45 67», «+994 50 123-45-67»,
// «994501234567», «501234567») приводится к +994 и 9 цифрам. Иностранный
// или неполный номер не трогаем: только пробелы по краям.
//
// Без серверных импортов: модуль читают сохранение анкеты (partnerFieldsRow),
// сравнение «было → стало» в кабинете и scripts/verify-admin-review.mts.
export function normalizePhoneAz(raw: string | null | undefined): string {
  const s = (raw ?? "").trim();
  const d = s.replace(/\D/g, "");
  if (d.length === 12 && d.startsWith("994")) return `+${d}`;
  if (d.length === 10 && d.startsWith("0")) return `+994${d.slice(1)}`;
  if (d.length === 9 && !s.startsWith("+")) return `+994${d}`;
  return s;
}
